'use client'

import AboutArea from '@component/pages/aboutArea'
import AboutAreaMenuControl, { MenuControlContent } from '@component/pages/aboutArea/menuControl'
import SearchTypeControl from '@component/pages/aboutArea/searchTypeControl'
import MapboxPolygon from '@component/mapbox/layer/polygon'
import RectLabel from '@component/pages/aboutArea/rectLabel'
import SectionLayout from '@component/layout/section'
import { isNumber, size } from 'lodash-es'
import { useRecoilValue } from 'recoil'
import { global } from '@store/index'
import { isCommercialData, isVillageData } from '@utils/house'

export default function HouseAboutArea({
  data
}) {

  const { isMobile } = useRecoilValue(global)
  const isCommercial = isCommercialData(data)
  const isVillage = isVillageData(data)

  const { lng, lat, regionId, propertyId, houseId, suburbId } = data
  if (!isNumber(lng) || !isNumber(lat)) return

  return (
    <SectionLayout title='About the area'>
      <AboutArea
        lng={lng}
        lat={lat}
        className='relative'
        mapBeforeChildren={
          isCommercial
            ? undefined
            : <MenuControlContent
              hasCensus
              regionId={regionId}
              lng={lng}
              lat={lat}
              id='property-about-area'
              suburbId={suburbId}
              propertyId={propertyId}
              houseId={houseId}
              isVillage={isVillage}
              className='block relative z-10 sm:hidden'
            />
        }
      >
        {
          size(data.boundaries) > 0 && (
            <>
              <MapboxPolygon autofitbounds={isMobile ? true : { padding: { top: 150, bottom: 150, left: 250, right: 150 } }} paths={[data.boundaries]}></MapboxPolygon>
              <RectLabel data={data}></RectLabel>
            </>
          )
        }
        {
          !isCommercial && (
            <AboutAreaMenuControl
              hasCensus
              regionId={regionId}
              lng={lng}
              lat={lat}
              id='property-about-area'
              suburbId={suburbId}
              propertyId={propertyId}
              houseId={houseId}
              isVillage={isVillage}
              className='hidden sm:block'
            ></AboutAreaMenuControl>
          )
        }
        {
          !isVillage && (
            <SearchTypeControl data={data}></SearchTypeControl>
          )
        }
      </AboutArea>
    </SectionLayout>
  )
}